// import needed stuff
import { i18n } from '@moxiltd/moxijs/src/i18n.js';
import browserUpdate from 'browser-update';
import { Form } from './form.js';
import * as functions from './functions.ts';
import { Tabs } from './components/tabs.js';
import { Accordion } from './components/accordion.js';
import { Modal } from './components/modal.js';
import { Slider } from './components/slider.js';

import './general.ts';
import './mobile-menu.ts';
import './map.ts';

// load polyfills if needed
import './legacySupport.js';
import 'scroll-timeline-polyfill/src/index.js';
import './animationTrigger.js';

// make moxi functions available from outside, e.g. templates
window.moxi = {
    i18n,
    Form,
    functions,
    Tabs,
    Accordion,
    Modal,
    Slider,
};

// browser update
window.browserUpdate = browserUpdate;

// trigger moxiJsLoaded event
document.dispatchEvent(new Event('moxiJsLoaded'));
